import { combineReducers } from "redux";
import { authReducer } from "./auth/authReducer";
import { boMonReducer } from "./category/boMonReducer";
import { chuDeReducer } from "./category/chuDeReducer";
import { donViHanhChinhReducer } from "./category/donViHanhChinhReducer";
import { giaoVienReducer } from "./category/giaoVienReducer";
import { heReducer } from "./category/heReducer";
import { hocKyDangKyReducer } from "./category/hocKyDangKyReducer";
import { khoaReducer } from "./category/khoaReducer";
import { monHocReducer } from "./category/monHocReducer";
import { mucTriNangReducer } from "./category/mucTriNangReducer";
import { ToChucThiReducer } from "./category/toChucThiReducer";
import { cauHoiReducer } from "./cau-hoi/cauHoiReducer";
import { nhomCauHoiReducer } from "./cau-hoi/nhomCauHoiReducer";
import { layoutReducer } from "./common/layoutReducer";
import { cauTrucDeThiReducer } from "./de-thi/cauTrucDeThiReducer";
import { chuDeThiInReducer } from "./de-thi/de-thi-in/chuDeThiInReducer";
import { nhomDeThiInReducer } from "./de-thi/de-thi-in/nhomDeThiInReducer";
import { deThiReducer } from "./de-thi/deThiReducer";
import { dotTaoDeReducer } from "./de-thi/dotTaoDeReducer";
import { QuanLyHocPhanReducer } from "./quyet-dinh/quanLyHocPhanReducer";
import { deThiInReducer } from "./de-thi/de-thi-in/deThiInReducer";
import { phanPhoiDeThiReducer } from "./de-thi/phanPhoiDeThiReducer";

const reducers = combineReducers({
  auth: authReducer,
  common: combineReducers({
    layout: layoutReducer,
  }),
  category: combineReducers({
    hocKyDangKy: hocKyDangKyReducer,
    mucTriNang: mucTriNangReducer,
    monHoc: monHocReducer,
    khoa: khoaReducer,
    donViHanhChinh: donViHanhChinhReducer,
    boMon: boMonReducer,
    giaoVien: giaoVienReducer,
    chuDe: chuDeReducer,
    toChucThi: ToChucThiReducer,
    he: heReducer,
  }),
  cauHoi: combineReducers({
    nhomCauHoi: nhomCauHoiReducer,
    cauHoi: cauHoiReducer,
  }),
  quyetDinh: combineReducers({
    quanLyHocPhan: QuanLyHocPhanReducer,
  }),
  deThi: combineReducers({
    dotTaoDe: dotTaoDeReducer,
    cauTrucDeThi: cauTrucDeThiReducer,
    deThi: deThiReducer,
    phanPhoiDeThi: phanPhoiDeThiReducer,
    deThiIn: combineReducers({
      nhomDeThiIn: nhomDeThiInReducer,
      chuDeThiIn: chuDeThiInReducer,
      deThiIn: deThiInReducer,
    }),
  }),
});

export default reducers;

export type RootState = ReturnType<typeof reducers>;
